export const capitalCase = (str?: string) => {
  if (!str) return '';
  return str
    .split(/\s|_/)
    .map((word) => {
      if (word.length > 1) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      } else return word;
    })
    .join(' ');
};

export const urlify = (text: string) => {
  const urlRegex =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
  return text.split(urlRegex).map((part) => {
    if (part.match(urlRegex)) {
      return (
        <a href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return part;
  });
};

export const constantify = (str: string) => str.toLowerCase().replaceAll(' ', '_');

export const prettifyConstant = (str: string) => {
  let capCase = capitalCase(str.replace(/[_-]/g, ' '));
  if (/hvac/i.test(capCase)) {
    capCase = capCase.replace(/hvac/i, 'HVAC');
  }
  if (/brn/i.test(capCase)) {
    capCase = capCase.replace(/brn/i, 'BRN');
  }
  if (/fmtl/i.test(capCase)) {
    capCase = capCase.replace(/fmtl/i, 'FMTL');
  }

  return capCase;
};

export const prettifyMarket = (str: string) => {
  let marketName = prettifyConstant(str);
  const regex = /(\s[A-Za-z][A-Za-z])$/gm;
  const result = marketName.match(regex);
  if (result) {
    marketName = marketName.replace(regex, ', ' + result[0].toUpperCase().trim());
  }
  return marketName;
};
